import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';
import { brandPrimary, inputBorderColor, titles, white } from '../../../styles/colors';
import { shadowMd, shadowSm } from '../../../styles/shadows';
import { CssSelectors, cardStyle } from '../../../styles/styles';

const cornerBadge = {
	borderRadius: 9999,
	boxShadow: shadowMd,
	boxSizing: 'border-box',
	color: white,
	fontSize: 10,
	fontWeight: THEME.typography.fontWeights.bold,
	padding: `${SPACE[4]}px ${SPACE[8]}px`,
} as const;

export const styleSheet = StyleSheet.create({
	body: {
		background: 'transparent !important',
		color: '#3F3F3F !important',
		fontFamily: 'Sora !important',
		fontSize: '14px !important',
		marginTop: 0,
		overflow: 'hidden',
	},
	buttonStack: {
		marginLeft: 20,
		marginRight: 20,
		marginTop: 12,
		marginBottom: 12,
	},
	clickNav: {
		':hover': {
			cursor: 'pointer',
		},
	},
	container: {
		...cardStyle,
		alignItems: 'stretch',
		border: `1px solid ${inputBorderColor}`,
		boxShadow: shadowSm,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		marginBottom: SPACE[32],
		overflow: 'visible',
		position: 'relative',
		width: 330,
		...CssSelectors.allChildren(
			{
				marginBottom: 12,
				marginLeft: 20,
				marginTop: 12,
			},
			'button'
		),
	},
	expiryBadge: {
		...cornerBadge,
		alignItems: 'center',
		backgroundColor: THEME.colors.warning.main,
		cursor: 'pointer',
		display: 'flex',
		gap: SPACE[4],
		':has(*) > svg': {
			display: 'block',
			height: 10,
			width: 10,
		},
	},
	header: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: SPACE[8],
		padding: `${SPACE[20]}px ${SPACE[20]}px 0`,
	},
	imageContainer: {
		alignItems: 'center',
		background: '#f9f9f9',
		display: 'flex',
		height: 210,
		justifyContent: 'center',
		margin: 0,
		overflow: 'hidden',
		padding: 0,
		paddingBottom: 24,
		position: 'relative',
		width: '100%',
		...CssSelectors.allChildren(
			{
				left: 0,
				width: '100%',
			},
			'img'
		),
	},
	newItem: {
		...cornerBadge,
		backgroundColor: brandPrimary,
	},
	sharedByFooter: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xxs,
		fontStyle: 'italic',
		textAlign: 'center',
		padding: `${SPACE[8]}px ${SPACE[16]}px 0`,
		marginTop: SPACE[8],
	},
	summaryPadding: {
		padding: SPACE[20],
		paddingBottom: SPACE[12],
	},
	textContainer: {
		height: 74,
	},
	title: {
		// @ts-expect-error - aphrodite doesn't support webkit box
		display: '-webkit-box',
		flex: 1,
		fontSize: 14,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
		minHeight: 32,
		minWidth: 0,
		overflow: 'hidden',
		textAlign: 'left',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: 2,
	},
	titleButton: {
		color: titles,
		fontSize: 'inherit',
		fontWeight: 'inherit',
		textAlign: 'left',
	},
	topCorner: {
		display: 'flex',
		gap: SPACE[8],
		position: 'absolute',
		right: -8,
		top: -8,
		zIndex: 1,
	},
});
